import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Button } from "@opensea/next-ui-kit";
import { Tooltip } from "@opensea/ui-kit";
import { isAddressEqual } from "@opensea/utils";
import { useContextSelector } from "use-context-selector";
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment";
import { useAddress } from "@/hooks/wallet";
import { CollectionSettingsContext } from "../collection/CollectionSettingsProvider";
import { TokenPrice } from "../price/TokenPrice";
import { useItemView } from "./ItemViewProvider";
import { useBuyItems } from "./use-buy-items";
import { useBuyItemsFragment } from "./use-buy-items.fragment";
export const BuyItemTableButtonFragment = graphql(`
    fragment BuyItemTableButton on Item {
      bestListing {
        pricePerItem {
          ...TokenPrice
        }
        marketplace {
          identifier
        }
        maker {
          address
        }
      }
      ...useBuyItems
    }
  `, [useBuyItemsFragment, TokenPriceFragment]);
export function BuyItemTableButton(t0) {
  const $ = _c(9);
  let itemKey;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      item: itemKey,
      size: t1,
      display: t2,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = itemKey;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
  } else {
    itemKey = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const size = t1 === undefined ? "xs" : t1;
  const display = t2 === undefined ? "standard" : t2;
  const item = readFragment(BuyItemTableButtonFragment, itemKey);
  const showMarketplaceLogos = useContextSelector(CollectionSettingsContext, _temp);
  const {
    disabledReason,
    disabled,
    buyItems
  } = useBuyItems([{
    ...item,
    quantity: 1
  }]);
  const address = useAddress();
  const {
    itemView
  } = useItemView();
  if (!item.bestListing) {
    let t3;
    if ($[5] !== display) {
      t3 = <TokenPrice display={display} price={null} />;
      $[5] = display;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  const tokenPrice = <TokenPrice className={showMarketplaceLogos ? "gap-1.5" : ""} display={display} marketplace={showMarketplaceLogos ? item.bestListing.marketplace?.identifier : undefined} marketplaceIconSize={itemView === "tableCompact" ? 12.5 : 15} price={item.bestListing.pricePerItem} />;
  if (isAddressEqual(item.bestListing.maker.address, address)) {
    return tokenPrice;
  }
  let t3;
  if ($[7] !== buyItems) {
    t3 = e => {
      e.preventDefault();
      e.stopPropagation();
      buyItems();
    };
    $[7] = buyItems;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return <Tooltip content={disabledReason} disabled={!disabled}><span className="max-w-full"><Button className="max-w-full font-normal" disabled={disabled} onClick={t3} size={size} variant="secondary" {...rest}>{tokenPrice}</Button></span></Tooltip>;
}
function _temp(state) {
  return state.showMarketplaceLogos;
}